// toursData.js
import scrollS1 from "../assets/images/scroll-s-1.jpg";
import scrollS2 from "../assets/images/scroll-s-2.jpg";
import scrollS3 from "../assets/images/scroll-s-3.jpg";
import scrollS4 from "../assets/images/scroll-s-4.jpg";
import scrollS5 from "../assets/images/scroll-s-5.jpg";
import scrollS6 from "../assets/images/scroll-s-6.jpg";

export const tours = [
  {
    id: "efficient",
    title: "All Efficient Tours",
    img: scrollS1,
    rating: "4.9 (523)",
    banner: "Best of Switzerland & Italy with FREE Excursion to Mount Titlis",
    packages: ["European Marvels", "Philippines Manila", "Dubai Explorer"],
    route: "/subcategory",
  },
  {
    id: "guided",
    title: "Guided Tours",
    img: scrollS2,
    rating: "4.8 (410)",
    banner: "Guided Tours – Explore with Experts",
    packages: ["Paris Walks", "Rome Guide", "London History"],
    route: "/subsubcategory",
  },
  {
    id: "hopoff",
    title: "Hop-off Tours",
    img: scrollS3,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
    route: "/subcategory",
  },
  {
    id: "hopoff-1",
    title: "Hop-off Tours",
    img: scrollS4,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
    route: "/subcategory",
  },
  {
    id: "hopoff-2",
    title: "Hop-off Tours",
    img: scrollS5,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
  },
  {
    id: "hopoff-3",
    title: "Hop-off Tours",
    img: scrollS6,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
  },
  {
    id: "hopoff-4",
    title: "Hop-off Tours",
    img: scrollS1,
    rating: "4.7 (390)",
    banner: "Hop-on Hop-off City Tours",
    packages: ["NYC Big Bus", "Singapore Bus", "Dubai City Bus"],
  },
];
